module.exports = __webpack_public_path__ + "static/media/space-bg.ef7b3759.png";